import React from "react";

import { DATASHEET_DEFAULT_FIELDS_DIMENSIONS } from "@modules/datasheets/components/editor/editor.constants";
import { DatasheetFieldComponentHeadingPosition } from "@common/dto/datasheet/field-component/heading-position";

import { IDatasheetEditorElement } from "../../datasheet.types";
import { useDatasheetElementController } from "../../hooks/datasheet-element.controller";
import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { DatasheetFieldComponentOriginFieldGetDto } from "@common/dto/datasheet/field-component/origin-field-dto";

export type TableFieldProps = IDatasheetEditorElement<DatasheetFieldComponentGetDto>;

export const useTableFieldController = (props: TableFieldProps) => {
  const {
    datasheetElement,
    containerRef,
    isSelected,
    onSelect,
    onCoordinatesChange,
    datasheetGridSettings,
    onResize,
    multipleElementsSelected,
    resizeHandlerStrategy,
    isTabOrderSettingActive,
  } = props;

  const datasheetElementController = useDatasheetElementController({
    isTabOrderSettingActive,
    resizeHandlerStrategy,
    datasheetElement,
    containerRef: containerRef,
    minWidth: DATASHEET_DEFAULT_FIELDS_DIMENSIONS[datasheetElement.original.field.fieldtype.typeid].width,
    minHeight: DATASHEET_DEFAULT_FIELDS_DIMENSIONS[datasheetElement.original.field.fieldtype.typeid].height,
    isSelected,
    onSelect,
    onCoordinatesChange,
    onResize,
    datasheetGridSettings,
    multipleElementsSelected,
  });

  const headingReference = React.useRef<HTMLDivElement>(null);

  const handleResizeColumn = React.useCallback(
    ({ field }: { field: DatasheetFieldComponentOriginFieldGetDto }) => {
      onResize(datasheetElement.id, {
        ...datasheetElement,
        original: {
          ...datasheetElement.original,
          field: {
            ...datasheetElement.original.field,
            dssubfields: datasheetElement.original.field.subfields?.map((subField) =>
              subField.fieldid === field.fieldid ? field : subField
            ),
          },
        },
      });
    },
    [onResize, datasheetElement]
  );

  React.useEffect(() => {
    datasheetElementController.handleHeadingSizeChange({
      width: headingReference.current?.offsetWidth || 0,
      height: headingReference.current?.offsetHeight || 0,
    });
  }, [
    datasheetElement.original.headtext,
    datasheetElement.original.headfontsize,
    datasheetElement.original.headfont,
    datasheetElement.original.headdisplay,
    datasheetElement.original.headpos,
  ]);

  const headingPosition = datasheetElement.original.headpos;
  const headingPlacedHorizontally = [
    DatasheetFieldComponentHeadingPosition.left,
    DatasheetFieldComponentHeadingPosition.right,
  ].includes(headingPosition);

  return {
    headingReference,
    headingPlacedHorizontally,
    headingPosition,
    handleResizeColumn,
    ...datasheetElementController,
  };
};
